import { uniq } from 'lodash';

import { notNil } from '@/lib/utils';
import type { Model } from '@/explore/types';

const getModelSection = (model: Model) => model.labels.section;

export const getModelSections = (models: Model[]) =>
  uniq(models.map(getModelSection).filter(notNil)).sort();
